// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.forgotpwd {
  margin-top: 18px;
  letter-spacing: normal !important;
  font-weight: bold;
  color: #727272 !important;
  font-size: small;
}

.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  text-align: center !important;
}

.alert-title.sc-ion-alert-md {
  font-size: 20px;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/app/authentication/signin/signin.page.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,iCAAA;EACA,iBAAA;EACA,yBAAA;EACA,gBAAA;AACF;;AACA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,6BAAA;AAEF;;AAAA;EACE,eAAA;EACA,iBAAA;AAGF","sourcesContent":[".forgotpwd {\n  margin-top: 18px;\n  letter-spacing: normal !important;\n  font-weight: bold;\n  color: #727272 !important;\n  font-size: small;\n}\n.footer {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  text-align: center !important;\n}\n.alert-title.sc-ion-alert-md {\n  font-size: 20px;\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
